import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/styles';
import { navTabsStyles } from '../material-styles';

const NavTabs = withStyles(navTabsStyles)(Tabs);

export default NavTabs;
